import HTTP from "../../utility/http";
import FILE from "@/utility/file";
import { asyncHandler } from "@/utility/async";

const state = {
  albums: [],
  queues: [],
};

const getters = {
  getAlbums: (state) => state.albums,
  getQueues: (state) => state.queues,
};

const actions = {
  add_queue({ commit }, queue) {
    commit("add_queue", queue);
    return true;
  },

  remove_queue({ commit }, queue) {
    commit("remove_queue", queue);
  },

  async delete_photo(context, data) {
    return await asyncHandler(
      HTTP({ url: "photo/delete/" + data.id, method: "GET" })
    );
  },

  async load_albums({ commit }) {
    const resp = await asyncHandler(HTTP({ url: "/album/all", method: "GET" }));
    if (resp.success) {
      commit("set_albums", resp.albums);
    }
    return resp;
  },

  async load_album({ commit }, albumId) {
    const resp = await asyncHandler(
      HTTP({ url: "/album/" + albumId, method: "GET" })
    );
    if (resp.success) {
      commit("set_albums", [resp.album]);
    }
    return resp;
  },

  async save_album(context, data) {
    const url = data.id ? "album/" + data.id : "album";
    const method = data.id ? "PUT" : "POST";
    return await asyncHandler(HTTP({ url, method, data }));
  },

  async upload_photo(context, data) {
    let formData = new FormData();
    formData.append("file", data.file);
    formData.append("album_id", data.album_id);
    formData.append("name", data.name);
    return await asyncHandler(
      FILE({ url: "/photo/upload", method: "POST", data: formData })
    );
  },
};

const mutations = {
  add_queue: (state, queue) => {
    const index = state.queues.findIndex((q) => q.id === queue.id);
    if (index === -1) {
      state.queues.unshift(queue);
    } else {
      state.queues[index] = queue;
    }
  },
  remove_queue: (state, queue) => {
    state.queues.splice(
      state.queues.findIndex((q) => q.id === queue.id),
      1
    );
  },
  set_albums: (state, albums) => {
    state.albums = albums;
  },
};

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state,
};
